import CryptoJS from 'crypto-js';
import jwtDecode from 'jwt-decode';

/**
 * Remover valores falsos de um vetor
 * https://www.geeksforgeeks.org/how-to-remove-falsy-values-from-an-array-in-javascript/
 * @param {*} arr [23, 0, "gfg", false, true, NaN, 12, "hi", undefined, [], ""]
 * @returns [23, "gfg", true, 12, "hi", []]
 */
export function removeFalsey(arr) {
  Object.keys(arr).forEach((key) => {
    if (!arr[key]) {
      delete arr[key];
    }
  });
}

/**
 * Buscar o contexto da empresa
 * @param {String} accessToken
 * @returns
 */
export const buscarEmpresaContexto = (accessToken) => {
  const tokenDecode = jwtDecode(accessToken);
  const requestUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/backend/usuario/buscar-empresa-contexto/${tokenDecode.sub}`;

  return new Promise((resolve, reject) => {
    fetch(requestUrl, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${accessToken}`,
        responseType: 'text',
      },
    })
      .then((response) => response.text())
      .then((response) => {
        localStorage.setItem('EC', encrypt(response));
        resolve();
      })
      .catch((error) => reject(error));
  });
};

export const encrypt = (text) => {
  const KEY = process.env.REACT_APP_ENCRYPT_KEY;
  return CryptoJS.AES.encrypt(text, KEY).toString();
};

export const decrypt = (textEncrypted) => {
  const KEY = process.env.REACT_APP_ENCRYPT_KEY;
  let bytes = CryptoJS.AES.decrypt(textEncrypted, KEY);
  return bytes.toString(CryptoJS.enc.Utf8);
};

export const getEmpresaContexto = () => {
  const empresaContextoEncrypted = localStorage.getItem('EC');

  if (empresaContextoEncrypted) {
    return decrypt(empresaContextoEncrypted);
  }
};

export const getIpRede = () => {
  const ipRedeEncrypted = localStorage.getItem('IP');

  if (ipRedeEncrypted) {
    return decrypt(ipRedeEncrypted);
  }
};
